import React from 'react';

const Button = ({ 
  children, 
  onClick, 
  disabled = false, 
  variant = 'default', 
  type = 'button',
  className = '',
  ...props 
}) => {
  const baseClass = 'action-button';
  const variantClass = variant !== 'default' ? `${variant}-button` : '';
  const classes = [baseClass, variantClass, className].filter(Boolean).join(' ');

  return (
    <button
      type={type}
      className={classes}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
